import { styled as muiStyled } from '@mui/material';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { COLORS } from '../../themes/colors';

import Collapse from '@mui/material/Collapse';

export const Wrapper = muiStyled(Stack)(() => ({
  border: `1px solid ${COLORS.MONOCHROMATIC.GRAY2}`,
  borderRadius: '8px 8px 8px 8px',
  transition: 'background-color 0.3s ease-in-out',
}));

export const Header = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  cursor: 'pointer',
  padding: '16px',
}));

export const StyledCollapse = muiStyled(Collapse)(() => ({
  borderRadius: '0 0 8px 8px',
  boxShadow: '0px 16px 24px rgba(0, 0, 0, 0.06)',
  background: COLORS.MONOCHROMATIC.GRAY1,
}));

export const FieldWrapper = muiStyled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const FilterButton = muiStyled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  background: COLORS.PRIMARY.BLUE.MAIN,
  border: `1px solid ${COLORS.PRIMARY.BLUE['-2']}`,
  borderRadius: '4px',
  padding: '6px',
  marginRight: '8px',
  cursor: 'default',

  '& .MuiTypography-root': {
    marginRight: '8px',
    fontWeight: 400,
    fontSize: '12px',
    color: COLORS.WHITE,
  },
}));

export const Calendar = muiStyled(Stack)(() => ({
  '&&': {
    borderRadius: '0 0 8px 8px',
    boxShadow: '0px 16px 24px rgba(0, 0, 0, 0.06)',
    backgroundColor: COLORS.MONOCHROMATIC.GRAY1,
    border: `1px solid ${COLORS.MONOCHROMATIC.GRAY2}`,
  },
}));
